import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import BackCircle from "../../components/Buttons/BackCircle";
import CloseCircle from "../../components/Buttons/CloseCircle";
import { Modal } from "../../components/Modal/Modal";
import FullHeightRow from "../../components/Row/FullHeightRow";
import Text from "../../components/Text/Text";
import back_circle from "../../imgs/back_circle.svg";
import close_circle from "../../imgs/close-circle.svg";

const TitleText = styled(Text)`
  width: 100%;
  position: absolute;
  font-weight: 500;
  font-size: 28px;
  top: 10%;
  left: 3%;
  margin-right: 10px;
  margin-top: 10px;
`;

const LicenseTypeContainer = styled.div`
  padding: 5%;
  display: flex;
  flex-direction: column;
  border: 0.5px solid #ffffff90;
  border-radius: 30px;
`;

const LicenseType = styled(FullHeightRow)`
position: relative;
background: #000D30;
min-width: 50%;
min-height: 70vh;
border-radius: 20px;
text-align: left;
`;

export const LicenseTypeModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ref = useRef();

  const onBackClick = () => {
    const previousLocation = location.pathname.replace("license_types", "");
    navigate(previousLocation);
  };

  return (
    <Modal
      ref={ref}
      show={true}
    >
      <LicenseType>
        <BackCircle bg={back_circle} onClick={onBackClick} />
        <CloseCircle onClick={() => {navigate("..")}} bg={close_circle} />
        <TitleText>Licenses Type</TitleText>
        <LicenseTypeContainer>
          <Text>License Type: Youtube</Text>
          <Text>License Earning: XXX ETH</Text>
          <Text>License Contract Created: 7/16/2022</Text>
        </LicenseTypeContainer>
      </LicenseType>
    </Modal>
  );
};
